module.exports = __webpack_public_path__ + "static/media/c_store_section_left.559fa4fb.png";